(function () {
  'use strict';

  function initStepper(stepper) {
    var input = stepper.querySelector('[data-kpb-stepper-input]');
    var decrease = stepper.querySelector('[data-kpb-stepper-decrease]');
    var increase = stepper.querySelector('[data-kpb-stepper-increase]');
    if (!input || !decrease || !increase) return;

    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 100;

    function setValue(value) {
      value = Math.min(max, Math.max(min, value));
      input.value = value;
      highlightTier(value);
    }

    function highlightTier(value) {
      var rows = document.querySelectorAll('.kpb__tiers-row[data-min-qty]');
      var activeRow = null;
      rows.forEach(function (row) {
        var minQty = parseInt(row.getAttribute('data-min-qty'), 10) || 0;
        row.classList.remove('is-active');
        if (value >= minQty && (!activeRow || minQty > parseInt(activeRow.getAttribute('data-min-qty'), 10))) {
          activeRow = row;
        }
      });
      if (activeRow) activeRow.classList.add('is-active');
    }

    decrease.addEventListener('click', function () {
      setValue((parseInt(input.value, 10) || min) - 1);
    });
    increase.addEventListener('click', function () {
      setValue((parseInt(input.value, 10) || min) + 1);
    });
    input.addEventListener('change', function () {
      setValue(parseInt(input.value, 10) || min);
    });

    highlightTier(parseInt(input.value, 10) || min);
  }

  document.querySelectorAll('[data-kpb-stepper]').forEach(initStepper);
})();
